module.exports = __webpack_public_path__ + "static/media/iloop.2fd83b1a.svg";